import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { Observable } from 'rxjs';
import { AlertComponent } from '../../Alerts/components/Alert/alert.component';
import { AlertsService } from '../../Alerts/services/alerts.service';

@Injectable()
export class AlertDeactivateGuard implements CanDeactivate<AlertComponent> {
    constructor(
        public alertsService: AlertsService
    ) {}

    canDeactivate(
        component: AlertComponent
    ): Observable<boolean> {
        return this.alertsService.showCanLeaveDialog();
    }
}
